import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Info, Radio, Target, Heart, Mail, Music, Users, Trophy, Star } from 'lucide-react'
import { APP_VERSION } from '../utils/appPrefs'
import './RadioPageTV.css'
import './AboutPageTV.css'

/* =====================================================================
   À PROPOS TV — même style que l'accueil, les Paramètres et le
   Classement TV : noir chaud, cartes #16140f, or #d4af37, tailles en vh.
   Un seul écran, aucune barre de défilement.
   ===================================================================== */

const CARDS = [
  {
    icon: Target,
    title: 'Notre mission',
    text: "Faire vivre l'héritage musical de Johnny pour toutes les générations."
  },
  {
    icon: Heart,
    title: 'Nos valeurs',
    text: 'Passion • Qualité • Communauté. Une radio créée par des fans, pour des fans.'
  },
  {
    icon: Mail,
    title: 'Contact',
    text: 'contact@johnnysjh.fr — Nous sommes à votre écoute.'
  }
]

const STATS = [
  { icon: Radio,  value: '24h/7j',  label: 'En direct' },
  { icon: Music,  value: '100 %',   label: 'Johnny Hallyday' },
  { icon: Users,  value: '+25 000', label: 'Auditeurs / jour' },
  { icon: Trophy, value: '50+ ans', label: 'De musique' }
]

export default function AboutPageTV() {
  const navigate = useNavigate()

  // Touche retour de la télécommande
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Backspace' || e.key === 'BrowserBack' || e.key === 'GoBack' || e.key === 'Escape' || e.keyCode === 10009) {
        e.preventDefault()
        navigate('/')
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [navigate])

  return (
    <div className="tvh tva">
      <header className="tva-head">
        <button type="button" className="tvh-btn" onClick={() => navigate('/')} data-tv-initial-focus="">
          <ArrowLeft size="1.1em" /> Accueil
        </button>
        <div className="tva-title">
          <span className="tva-title__icon"><Info /></span>
          <div>
            <h1>À propos</h1>
            <p>Radio 100% Johnny</p>
          </div>
        </div>
        <span className="tva-version">Version {APP_VERSION}</span>
      </header>

      <main className="tva-main">
        {/* PRÉSENTATION */}
        <section className="tva-hero">
          <img src="/images/logo.png" alt="" className="tva-hero__logo" />
          <h2>Radio 100% Johnny</h2>
          <p>
            La seule radio entièrement dédiée à Johnny Hallyday.
            <br />
            Écoutez le meilleur du rock français 24h/24, 7j/7.
          </p>
          <div className="tva-hero__foot">
            <Star size="1em" fill="currentColor" /> Made with ♥ by fans, for fans
          </div>
        </section>

        {/* MISSION / VALEURS / CONTACT */}
        <section className="tva-cards">
          {CARDS.map(({ icon: Icon, title, text }) => (
            <div key={title} className="tva-card">
              <span className="tva-card__icon"><Icon /></span>
              <div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </section>

        {/* CHIFFRES */}
        <section className="tva-stats" aria-label="La radio en chiffres">
          {STATS.map(({ icon: Icon, value, label }) => (
            <div key={label} className="tva-stat">
              <Icon />
              <strong>{value}</strong>
              <span>{label}</span>
            </div>
          ))}
        </section>
      </main>

      <footer className="tva-foot">
        <span>OK : revenir à l'accueil</span>
        <span>↩ Retour : revenir à l'accueil</span>
      </footer>
    </div>
  )
}
